var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"blue","icon":"","small":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-bank-plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }